import Vue from 'vue'
import Router from 'vue-router';
import about from "@/views/about"
import blindbox from '@/views/blindbox'; // 了解盲盒
import appOpenBox from "@/views/appModel/openBox" // 打开盲盒 app
import prodDetail from "@/views/appModel/prodDetail" // app 出售作品详情
import appPayment from "@/views/appModel/payment" // 支付页 安卓ios专用
import appPaymentSuccess from "@/views/appModel/paymentSuccess" // 支付成功结果页
import privacyPolicy from "@/views/privacyPolicy" // 隐私协议
import cancellationAgreement from "@/views/cancellationAgreement" //cancellationAgreement
import terms from "@/views/terms" // 使用条款
import termsA from "@/views/termsA" // 登录时的强制用户阅读的使用协议
import download from "@/views/download" //安卓app下载
import detailedRules from "@/views/detailedRules"//抽签码详细规则
import sharedList from "@/views/sharedList" //安卓共享清单
import sharedListFast from "@/views/sharedListFast" //安卓共享清单极速版
import appBankList from "@/views/appModel/bankList" //宝付银行卡列表 app极速版
import appAddBank from "@/views/appModel/addBank" //宝付添加银行卡 app极速版
import bankAgreement from "@/views/bankAgreement" //银联用户协议
import appBankAgreement from "@/views/appModel/bankAgreement" //银联用户协议 app极速版
import myDomainName from "@/views/myCenter/myDomainName" //我的域名
import poapRule from "@/views/poap/poapRule" // poap 规则页面
import PrivacypolicyAndroid from "@/views/PrivacypolicyAndroid"
import informationListAndroid from "@/views/informationListAndroid" // 应用收集个人信息清单
import informationListIos from "@/views/informationListIos" // 应用收集个人信息清单
import usageAgreement from "@/views/usageAgreement" //数字资产使用协议
import userAgreementAndroid from "@/views/userAgreementAndroid" // 安卓用户协议
import PrivacypolicyAndroidNew from "@/views/PrivacypolicyAndroidNew" //安卓隐私政策新
import rechargeAgreement from "@/views/rechargeAgreement" //充值协议
import otherPrivacypolicyAndroid from "@/views/otherPrivacypolicyAndroid" //安卓隐私协议
import otheruserAgreementAndroid from "@/views/otheruserAgreementAndroid"
import boheSuger from "@/views/boheSuger/index" //薄荷糖充值
import publicAgreement from "@/views/publicAgreement" //统一协议页面 根据传值不同


Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}
export default new Router({
  mode: "history",
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes: [
    {
      path: "/blindbox",
      name: "blindbox",
      component: blindbox,
    },
    {
      path: "/appOpenBox",
      name: "appOpenBox",
      component: appOpenBox,
      meta: {
        keepAlive: true,
      }
    },


    {
      path: "/prodDetail",
      name: "prodDetail",
      component: prodDetail,
    },

    {
      path: "/appPayment",
      name: "appPayment",
      component: appPayment,
    },
    {
      path: "/appPaymentSuccess",
      name: "appPaymentSuccess",
      component: appPaymentSuccess,
      meta: {
      }
    },
    {
      path: "/boheSuger",
      name: "boheSuger",
      component: boheSuger
    },
    {
      path: "/aboutus",
      name: "about",
      component: about
    },

    {
      path: "/download",
      name: "download",
      component: download
    },

    {
      path: "/detailedRules",
      name: "detailedRules",
      component: detailedRules,
    },
    {
      path: "/sharedList",
      name: "sharedList",
      component: sharedList
    },
    {
      path: "/sharedListFast",
      name: "sharedListFast",
      component: sharedListFast
    },

    {
      path: "/appBankList",
      name: "appBankList",
      component: appBankList,
    },
    {
      path: "/appAddBank",
      name: "appAddBank",
      component: appAddBank
    },
    {
      path: "/bankAgreement",
      name: "bankAgreement",
      component: bankAgreement
    },
    {
      path: "/appBankAgreement",
      name: "appBankAgreement",
      component: appBankAgreement
    },


    {
      path: "/myDomainName",
      name: "myDomainName",
      component: myDomainName
    },


    {
      path: "/poapRule",
      name: "poapRule",
      component: poapRule
    },

    {
      path: "/PrivacypolicyAndroid",
      name: "PrivacypolicyAndroid",
      component: PrivacypolicyAndroid
    },
    {
      path: '/cancellationAgreement',
      name: "cancellationAgreement",
      component: cancellationAgreement
    },
    {
      path: "/informationListAndroid",
      name: "informationListAndroid",
      component: informationListAndroid
    },
    {
      path: "/informationList",
      name: "informationListIos",
      component: informationListIos
    },
    {
      path: "/usageAgreement",
      name: "usageAgreement",
      component: usageAgreement
    },
    {
      path: "/userAgreementAndroid",
      name: "userAgreementAndroid",
      component: userAgreementAndroid
    },
    {
      path: "/PrivacypolicyAndroidNew",
      name: "PrivacypolicyAndroidNew",
      component: PrivacypolicyAndroidNew
    },
    {
      path: "/rechargeAgreement",
      name: "rechargeAgreement",
      component: rechargeAgreement
    },
    {
      path: "/otherPrivacypolicyAndroid",
      name: "otherPrivacypolicyAndroid",
      component: otherPrivacypolicyAndroid
    },
    {
      path: "/otheruserAgreementAndroid",
      name: "otheruserAgreementAndroid",
      component: otheruserAgreementAndroid
    },
    {
      path: "/publicAgreement",
      name: "publicAgreement",
      component: publicAgreement
    },
    {
      path: "/agreement",
      name: "terms",
      component: terms,
    },
    {
      path: "/termsA",
      name: "termsA",
      component: termsA,
    },
    // {
    //   path: "*", // 此处需特别注意置于最底部
    //   redirect: "/404"
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js